import { isObject, get } from 'lodash';
import Config from 'config/Config';
import Language from 'config/langs';
import { GetXhr } from 'utils/baseRequest';
import Utils from 'utils';

class CubeI8N {
  constructor(data = {}) {
    this.data = data;
  }
  /**
   *
   * 根据键名，获取多语言数据
   * @param obj {string | object} 如果obj为string类型，则直接作为键名
   * @param obj.name {string} 键名，可以是  a.b.c 格式
   * @param obj.values {array<object>} 需要在字符串中做替换的数据源  values:[{name:"蛤蛤"}]   在值中就可以拿到  a:"abc{name}cc"
   * @param languageData {object} 数据源，默认为脚手架的语言包
   * @param defaultValue {string} 默认数据
   * @return {string}
   */
  getString = (obj, defaultValue) => {
    let data = get(this, 'data');
    // Language
    let val = isObject(obj) ? get(data, get(obj, 'name'), '') : get(data, obj, '');
    !val ? val = isObject(obj) ? get(Language, get(obj, 'name'), '') : get(Language, obj, '') : ''; //如果没有取到信息，将去公共包中取
    let values = get(obj, 'values', "");
    //填充字符串模版
    if (values && isObject(values)) {
      val = Utils.strFormat(val, get(obj, 'values', {}))
    }
    return val ? val : defaultValue;
  }
  /**
  *
  * 获取多语言包
  * @param moduleName {string} 模块名，查看自身属于哪个模块
  * @param router {string} 当前页面的层级，决定会从模块下的哪个文件夹取语言包
  * @return {Promise}
  */
  static getLanguageData({ moduleName = "", router }) {
    let isHttp = () => {
      let publicPath = Config.publicPath;
      if (!publicPath || (publicPath.indexOf("http:") == -1 && publicPath.indexOf("https:") == -1)) {
        publicPath = Config.getRootPath();
      }
      return publicPath;
    }
    // let url = "https://yunxi-dev.oss-cn-shenzhen.aliyuncs.com/yunxi-dev-huieryun/home/eF6JPkywC7NiiW.json"
    let url = `${isHttp()}/assets/moduleAssets/assets-${moduleName}/langs/${Config.languageEnv}/${router}/index.json`;
    let jqrequest = new GetXhr(url);
    return jqrequest.send();
  }

  //打印出中英文格式语言L
  static formatLanguage = (dataString = '') => {
    const formatDataArr = dataString.toString().split(/[\n]/)
    let ChineseObj = {}, EnglishObj = {};
    //中文
    formatDataArr.forEach(val => {
      let key = '', value='';
      val.split(' ').filter(val => val!=='').forEach((item,i) => {
        if(i===0) {
          value = item
        }else {
          key = key + item.charAt(0).toUpperCase() + item.slice(1)
        }
      })
      const KEY = key.charAt(0).toLowerCase()+key.slice(1)
      ChineseObj = {...ChineseObj, [KEY]: value}
    })
    //英文
    formatDataArr.forEach(val => {
      let key = '', value='';
      val.split(' ').filter(val => val!=='').forEach((item,i) => {
        if(i>0) {
          key = key + item.charAt(0).toUpperCase() + item.slice(1)
        }
      })
      let valArr = val.split(' ').filter(val => val!=='')
      valArr.splice(0,1)
      const KEY = key.charAt(0).toLowerCase()+key.slice(1)
      EnglishObj = {...EnglishObj, [KEY]: valArr.join(' ')}
    })

    console.log(ChineseObj, EnglishObj)
  }
}

export default CubeI8N;


// WEBPACK FOOTER //
// ./src/utils/cubeI8N.js